// @ts-nocheck -- TAPP payroll compatibility boundary
import { createContext, useContext, type ReactNode } from "react";

import type { Session } from "../../api.js";

interface PayrollUser {
  id: string;
  username: string;
  displayName: string;
  email: string;
}

const AuthContext = createContext<PayrollUser | null>(null);

export function PayrollAuthProvider({
  session,
  children,
}: {
  session: Session;
  children: ReactNode;
}) {
  const displayName = session.principal.displayName ?? "PayDay user";
  return (
    <AuthContext.Provider
      value={{
        id: session.principal.id,
        username: displayName,
        displayName,
        email: "",
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const user = useContext(AuthContext);
  return {
    data: user === null ? undefined : { user },
    isLoading: false,
    isError: false,
    error: null,
  };
}
